import { startCase } from "lodash-es";

import { ExclamationCircleSolid } from "@smartrent/icons";
import { HStack, Typography, useTheme, VStack } from "@smartrent/ui";

import { HubRefurbishErrorNames, RunHubRefurbishBatchJobError } from "@/types";

export const HubRefurbishErrorMessage = ({
  name,
  message,
}: RunHubRefurbishBatchJobError["error"]["context"]) => {
  const { colors } = useTheme();

  // these errors names should all be bubbled up from support-api
  const errorName = startCase(name || HubRefurbishErrorNames.UnexpectedError);

  const errorMessage =
    message ||
    "We encountered an unexpected error, please try again and contact engineering if this issue persists.";

  return (
    <VStack spacing={8} align="start" wrap={true} style={{ flex: 1 }}>
      <HStack align="center" spacing={4}>
        <ExclamationCircleSolid color={colors.warning} size={14} />{" "}
        <Typography type="bodySemibold">{errorName}</Typography>
      </HStack>
      <Typography type="body" numberOfLines={3}>
        {errorMessage}
      </Typography>
    </VStack>
  );
};
